import React from 'react'
import romtechLogo from '../assets/romtech-logo.svg'
import Image from 'next/image'

const RomtechLogoHeader = () => {
  return (
    <div className="bg-white py-3 px-5"><Image src={romtechLogo} width="30" height="35"/></div>
  )
}

export default RomtechLogoHeader